// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { productAvailabilityStyles } from "@stoneage/Overrides/Components/ProductAvailability";
import { color, nestedTableRowCss } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

productAvailabilityStyles.availabilityByWarehouseModal = {
    size: 638,
    cssOverrides: {
        modalContent: css`
            padding: 21px;
        `,
        modalTitle: css`
            padding: 21px 21px 0;
        `,
        headlineTypography: css`
            font-size: 20px;
            margin-bottom: 0;
        `,
        scrim: css`
            z-index: 1306;
        `,
    },
};

productAvailabilityStyles.availabilityByWarehouseLink = {
    typographyProps: {
        size: 12,
        lineHeight: "18px",
        css: css`
            &:hover ${TypographyStyle} {
                color: ${color("text.link")};
            }
        `,
    },
};

productAvailabilityStyles.warehouseNameTableCell = productAvailabilityStyles.branchNameTableCell = {
    css: css`
        display: flex;
        align-items: center;
    `,
};

productAvailabilityStyles.branchArrowIcon = {
    css: css`
        cursor: pointer;
        margin-left: 28px;
        margin-right: 12px;
    `,
};

productAvailabilityStyles.toggleIcon = {
    css: css`
        cursor: pointer;
        margin-right: 12px;
    `,
};

productAvailabilityStyles.availabilityByBranchTableRow = {
    css: nestedTableRowCss,
};
